/**
 * @author        quanquan
 * @dateTime      2020-07-24 15:06:21
 * @description   merchant common
 */

import _ from 'lodash'
import Vue from 'vue'
import store from '@/conf/home/store'
import { checkip } from '@/module/utils'
import cookie from '@fedor/cookie'
import { ignoreUrl } from '@/module/layout/_source/utils'

const MC = () => new InnerCtor()

class InnerCtor {
  constructor () {
    this.domain = window.location.host
    this.domainArr = this.domain.split('.')
    this.domainLen = this.domainArr.length
    this.config = {
      authList: [],
      isPALocal: true,
      env: this.handlerEvn(),
      system: this.getCookie('mc-system'),
      userName: this.getCookie('mc-username')
    }
  }

  init () {
    this.directive()
  }

  singOut () {
    store.$store.dispatch('common/logOut')
  }

  isAuth (resUrl, $resList) {
    const { authList } = this.config
    const resList = store.state.common.resList

    let ignore = _.cloneDeep(_.map(ignoreUrl, v => v.path))

    if (!authList.length) {
      const a = _(resList).map('children').filter().flatMap().value()
      const b = _(a).map('children').filter().flatMap().value()
      const c = _(b).map('children').filter().flatMap().value()
      const d = _.compact(_.map(_.concat(a, b, c), v => v.reUrl && v.reUrl))
      this.setConfig({ resList, authList: d })
      ignore = _.concat(ignore, d)
    } else {
      ignore = _.concat(ignore, authList)
    }
    if (ignore.includes(resUrl)) {
      return true
    } else {
      return false
    }
  }

  isIp () {
    return checkip(window.location.hostname)
  }

  parsingSystemLabel (resList) {
    const a = _(resList).map('children').filter().flatMap().value()
    const b = _(a).map('children').filter().flatMap().value()
    const c = _(b).map('children').filter().flatMap().value()
    const d = _.compact(_.map(_.concat(a, b, c), v => v.reUrl && v.reUrl))
    return _.concat(_.cloneDeep(_.map(ignoreUrl, v => v.path)), d)
  }

  // Obtain the environmental label based on the domain name
  handlerEvn () {
    const h = window.location.host
    if (h.indexOf('localhost') === 0) {
      return 'local'
    }
    if (h.indexOf('dev') !== -1) {
      return 'dev'
    }
    if (h.indexOf('test') !== -1) {
      return 'test'
    }
    if (h.indexOf('uat') !== -1) {
      return 'uat'
    }
    if (this.isIp()) {
      return 'IPproduction'
    }
    return 'production'
  }

  setAuth (t) {
    const { userName, env } = this.config
    this.setCookie(`Authorization_${userName}_${env}`, t)
    if (env !== 'IPproduction' && env !== 'production' && env !== 'local') {
      this.setCookie(`Authorization_help`, t, `.${env}.ydjia.cn`) // 增加一个token  用于帮助中心
    } else {
      this.setCookie(`Authorization_help`, t) // 增加一个token  用于帮助中心
    }
  }

  getAuth () {
    const { userName, env } = this.config
    return cookie.get(`Authorization_${userName}_${env}`)
  }

  // set this domain cookie.
  setCookie (key, val = '', domain = this.domain) {
    const { env } = this.config
    if (env === 'IPproduction') {
      domain = window.location.hostname
    }

    if (env === 'production') {
      domain = `.${this.domainArr[this.domainLen - 2]}.${this.domainArr[this.domainLen - 1]}`
    }

    cookie.set(key, val, { domain:env === 'local' ? 'localhost' : domain , path: '/' }) // eslint-disable-line
  }

  getCookie (key) {
    return cookie.get(key)
  }

  delCookie (name) {
    var val = this.getCookie(name)
    const { env } = this.config
    let domain = this.domain
    if (env === 'IPproduction') {
      domain = window.location.hostname
    }
    if (env === 'production') {
      domain = `.${this.domainArr[this.domainLen - 2]}.${this.domainArr[this.domainLen - 1]}`
    }

    cookie.set(name, val, { domain:env === 'local' ? 'localhost' : domain , path: '/' ,expires:-1}) // eslint-disable-line
  }

  // 清理帆软cookie
  delFrCookie () {
    var keys = document.cookie.match(/[^ =;]+(?==)/g)
    if (keys) {
      for (var i = keys.length; i--;) {
        document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString()
        document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString()
        // document.cookie = keys[i] + '=0;path=/;domain=hydee.cn;expires=' + new Date(0).toUTCString()
      }
    }
  }

  // clean this domain all cookie.
  cleanCookie () {
    const cookieArr = document.cookie.match(/[^ =;]+(?=\=)/g) // eslint-disable-line
    // _.map(cookieArr, v => this.setCookie(v))
    _.map(cookieArr, v => this.delCookie(v))
    // 删除 帮助中心种植的token
    const { env } = this.config
    if (env !== 'IPproduction' && env !== 'production' && env !== 'local') {
      this.setCookie(`Authorization_help`, '', `.${env}.ydjia.cn`) // 增加一个token  用于帮助中心
    } else {
      this.setCookie(`Authorization_help`, '') // 增加一个token  用于帮助中心
    }
  }

  // set constructor config info
  setConfig (cfg) {
    // update cookie system value
    if (cfg && cfg.system) {
      this.setCookie('mc-system', cfg.system)
    }
    // update cookie mercode value
    if (cfg && cfg.merCode) {
      this.setCookie('mc-mercode', cfg.merCode)
    }

    if (cfg && cfg.userName) {
      this.setCookie('mc-username', cfg.userName)
    }

    if (cfg && cfg.userInfo) {
      cfg.sysList = _.map(cfg.userInfo.allHasSys, v => {
        return {
          value: v.reEngSystem,
          label: v.reSystem
        }
      })
    }

    this.config = _.assign(this.config, cfg)
    Vue.prototype.__MCoptions = _.assign(Vue.prototype.__MCoptions, cfg)
  }
  get (str) {
    const { resList = [] } = this.config.userInfo
    const handlerResList = (arr) => {
      return arr.reduce((p, c) => {
        p[c.rePath] = c.children ? handlerResList(c.children) : {}
        return p
      }, {})
    }
    return !_.has(handlerResList(resList), str)
  }

  // handler auth directive function
  directive ($Vue = Vue) {
    $Vue.directive('auth', {
      bind: (el, binding, vnode) => {
        const { rawName } = binding
        if (this.get(_.split(rawName, ':')[1])) {
          $(el).addClass('is-disabled').remove() // eslint-disable-line
        }
      }
    })
    $Vue.directive('auth-delete', {
      bind: (el, binding, vnode) => {
        const { rawName } = binding
        if (this.get(_.split(rawName, ':')[1])) {
          $(el).hide() // eslint-disable-line
        }
      }
    })
  }
}

export default MC()



// WEBPACK FOOTER //
// ./src/js/module/MC/index.js